var global = require('../internals/global');
var setToStringTag = require('../internals/set-to-string-tag');

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/modules/es.json.to-string-tag.js